<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>

<template>
    <v-dialog v-model="handleDialog" width="700"class="common-dialog">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center text-h4">
                <slot name="title"></slot>
            </v-card-title>
            <v-card-text
                    class="text-center common-dialog-message"
                >
                <slot name="message"></slot>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="justify-center grey lighten-4 pb-6">
                <v-btn min-width="150px" class="white--text" color="red" large @click="pushOk">
                    <slot name="ok-btn"></slot>
                </v-btn>
                <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false">
                    <slot name="cancel-btn"></slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            alertItem: this.item, // 子で親のインスタンスを更新するので、一度変数に移す（オブジェクトだが大丈夫か？）
        };
    },
    props: {
        deleteDialog: Boolean,
        item: {
            id: Number,
        },
    },
    computed: {
        handleDialog: {
            get() {
                return this.deleteDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:deleteDialog', value);
            }
        },
        alertId: {
            get() {
                return this.alertItem.id;
            },
            set(value) {
                this.alertItem.id = value;
            }
        },
    },
    methods: {
        // 削除
        deleteItem: function() {
            axios.post(this.alertItem.table + this.alertItem.id, {
            }).then(res => {
                // 親コンポーネントへの通知
                if (res.data['success']) {
                    this.$emit("success", res.data['message']);
                    this.handleDialog = false;
                } else {
                    this.$emit("error", res.data['message']);
                }
            }).catch(res => {
            }).finally(() => {
            });
        },

         // 削除確認ダイアログで削除を押下
        pushOk() {
            this.deleteItem();
        },
    },
};
</script>